import { makeStyles } from '../styles/tss-react';

export const useStyles = makeStyles({ name: 'RichText' })(
  ({ palette, typography: { pxToRem: themePxToRem } }) => ({
    link: {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit',
      color: palette.semantic.text.hyperlink,
      textDecoration: 'underline',
      textDecorationThickness: themePxToRem(1),
      '&:hover': {
        color: palette.semantic.text.hyperlinkHover,
      },
    },
  })
);
